// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7536) return "static/chunks/7536-9155e18d42e95cfd.js";
	if (chunkId === 2196) return "static/chunks/ee8b1517-88c3f2f124110d87.js";
	if (chunkId === 9421) return "static/chunks/9421-d33052f6fd3998d5.js";
	if (chunkId === 3539) return "static/chunks/3539-cce12ce14473e9ca.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1819":"798ddde6f1605fa5","2415":"a791056e962a1b92","3119":"f6f50b0514ad1e84","5908":"c0365879a7d7c815","6721":"afc33c7e57256f17","7368":"cfd96c687fe7a710","8871":"faf559c47a652881","9319":"2c663bc186d0dd82"}[chunkId] + ".js";
};